import { Box, Container, Heading, Text, VStack, Link, Icon } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <Box h="100vh" overflowY="auto" bg="gray.50" py={10}>
            <Container maxW="container.md" bg="white" p={8} borderRadius="xl" boxShadow="md">
                <VStack spacing={6} align="start">
                    <Link as={RouterLink} to="/login" color="brand.500" fontWeight="bold" display="flex" alignItems="center">
                        <Icon as={ArrowBackIcon} mr={2} />
                        返回登入頁 (Back to Login)
                    </Link>

                    <Heading as="h1" size="xl" color="brand.800">隱私權政策 (Privacy Policy)</Heading>
                    <Text fontSize="sm" color="gray.500">生效日期：2026年3月25日</Text>

                    <Box w="full">
                        <Heading as="h2" size="md" mb={3} mt={6}>1. 適用範圍</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            本隱私權政策適用於「天籟徐薇補習班平台」及其相關行動應用服務，用於說明本服務如何蒐集、使用、保存、刪除與保護您的個人資料。
                            若您使用本服務，即表示您同意依本政策處理相關資料。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>2. 我們蒐集的資料類型</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            我們僅蒐集提供補習班管理、親師溝通與接送安全功能所必要的資料，可能包括：
                            <br />• 帳號資料：姓名、身分別、聯絡方式、登入資訊
                            <br />• 學生與班務資料：學生姓名、班級、出缺勤、接送與通知紀錄
                            <br />• 裝置資料：裝置代碼（Device Token）、必要的系統與錯誤診斷資訊
                            <br />• 定位資料：當家長主動啟用接送相關功能，例如「我已出發」後，本 App 會蒐集裝置的位置資料（可能包含精確位置與概略位置）
                            ，並在功能進行期間於前景或背景持續更新位置，以便提供接送到達提醒、預估到達時間與校方接送準備。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>3. 定位資料的使用方式</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            定位資料僅用於與接送安全直接相關的功能，包括：
                            <br />• 當家長出發接送學生時，通知老師或行政人員家長接近補習班
                            <br />• 顯示接送狀態、距離或預估到達時間
                            <br />• 協助校方提前完成學生接送準備，提高安全與效率
                            <br />• 在功能結束後停止不必要的定位更新
                            <br /><br />
                            我們不會將定位資料用於廣告投放，也不會將定位資料出售給第三方。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>4. 資料使用與分享</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            我們蒐集的資料僅用於補習班內部管理、親師溝通、到離班通知、接送安全與系統運作維護。
                            資料可能在以下必要範圍內提供給相關人員或服務：
                            <br />• 補習班內之老師、行政人員與管理人員，用於履行教育管理與接送安全職責
                            <br />• 受委託提供雲端主機、推播通知、地圖或系統維運服務之合作服務商
                            <br />• 法令要求或主管機關依法要求時
                            <br /><br />
                            除前述情形外，我們不會任意出售、出租或揭露您的個人資料。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>5. 資料保存、刪除與安全</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            我們會在達成前述目的所需期間內保存資料，並採取合理的管理與技術措施保護資料安全，包括傳輸保護、權限控管與必要的操作紀錄。
                            當您不再使用本服務，或依法得請求刪除資料時，可依本政策所列方式提出申請；我們將在確認身分後，依適用法令與實際業務需求處理刪除或去識別化作業。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>6. 您的權利</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            您可以依適用法令要求查詢、閱覽、更正、補充、停止使用或刪除您的個人資料。
                            您也可以隨時於裝置系統設定中調整或撤銷定位權限，但部分接送功能可能因此無法正常運作。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>7. 聯絡我們</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            如果您對本隱私權政策、帳號刪除、資料處理方式或定位資料使用有任何疑問，請透過補習班官方聯絡管道與我們聯繫，
                            或來信至 naturaledu88@gmail.com。我們將於確認身分後協助處理。
                        </Text>
                    </Box>
                </VStack>
            </Container>
        </Box>
    );
};

export default PrivacyPolicy;
